export default "__VITE_ASSET__CyYS86M3__"